import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoidPaymentListComponent } from './void-payment-list.component';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { LoanService } from 'src/app/services/loan.service';



@NgModule({
  declarations: [VoidPaymentListComponent],
  imports: [
    CommonModule,
    PosTableModule
  ],
  providers: [LoanService],
  exports: [VoidPaymentListComponent]
})
export class VoidPaymentListModule { }
